import axios from "axios";

// constants
import { BASE_URL, DEV_URL, EVENT_URL } from "src/utils/constants";

// utils
import { getCurrentDate } from "src/utils/dateHelper";

export const getCategories = (_userID) => {
  const response = axios({
    method: "post",
    url: `${BASE_URL()}/Category`,
    data: {
      userID: _userID,
    },
  });

  return response;
};

export const getEventByCategory = (_data) => {
  let now = getCurrentDate();

  // let data = {
  //   // userId: _data?.userId || 0,
  //   userId: 0,
  //   latitude: _data?.lat || "40.303707",
  //   longitude: _data?.lng || "-72.92622",
  //   categoryId: _data.catgId,
  //   pageNumber: _data?.pageNumber || 1,
  //   totalPageCount: _data?.limit || 12,
  //   // accessToken: _data?.accessToken || "",
  //   accessToken: "",
  //   DateTimeNow: now.prettier.dateTimeNow,
  //   IsFromWeb: "true",
  //   sortOrder: "date",
  // };

  let data = {
    accessToken: "",
    latitude: _data?.lat || "41.7657461",
    longitude: _data?.lng || "-72.7151064",
    categoryId: _data.catgId,
    dateTimeNow: now.prettier.dateTimeNow,
    totalPageCount: _data?.limit || 12,
    pageNumber: _data?.pageNumber || 1,
    sortOrder: "date",
    isFromWeb: "1",
  };

  const response = axios({
    method: "POST",
    url: `${BASE_URL()}/NewEvent`,
    data: data,
  });

  return response;
};
